import React, { useState } from "react";
import { Container, Row, Col, Form, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Signup.css";
import { useSignupMutation } from "../services/appApi";

function Signup() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [name, setName] = useState("");
    const [signup, { error, isLoading, isError }] = useSignupMutation();

    function handleSignup(e) {
        e.preventDefault();
        signup({ name, email, password });
    }

    return (
        <Container>
            <Row>
            <Col md={6} className="signup__image--container"></Col>
                <Col md={6} className="signup__form--container">
                    <Form style={{ width: "100%" }} onSubmit={handleSignup} >
                        <h1>Create an account</h1>
                        {isError && <Alert variant="danger">{error.data}</Alert>}
                        <Form.Group className="form-group">
                            <Form.Label className="form-label">Name</Form.Label>
                            <Form.Control type="text" placeholder="Your name" className="form-input" value={name} required onChange={(e) => setName(e.target.value)} />
                        </Form.Group>

                        <Form.Group className="form-group">
                            <Form.Label className="form-label">Email Address</Form.Label>
                            <Form.Control type="email" placeholder="Enter email" className="form-input" value={email} required onChange={(e) => setEmail(e.target.value)} />
                        </Form.Group>

                        <Form.Group className="mb-3 form-group">
                            <Form.Label className="form-label">Password</Form.Label>
                            <Form.Control type="password" placeholder="Enter Password" className="form-input" value={password} required onChange={(e) => setPassword(e.target.value)} />
                        </Form.Group>

                        <Form.Group>
                            <Button type="submit" disabled={isLoading}>
                                Create account
                            </Button>
                        </Form.Group>
                        <p className="pt-3 text-center">
                        Already have an account? <Link to="/login">Login</Link>{" "}
                        </p>
                    </Form>
                </Col>
            </Row>
        </Container>
    );
}

export default Signup;
